import { ThemeColor, ThemeService, ThemeTonalRange } from "@philips-internal/oswald-ui-components/lib/services";

function setup(): void {
  ThemeService.setColors(ThemeColor.GROUP_BLUE, ThemeColor.GREEN);
  ThemeService.setContentTonalRange(ThemeTonalRange.BRIGHT);
  ThemeService.setNavigationTonalRange(ThemeTonalRange.BRIGHT);
}

export {
  setup,
};
